import script from "./index3.vue?vue&type=script&setup=true&lang=js"
export * from "./index3.vue?vue&type=script&setup=true&lang=js"

import "./index3.vue?vue&type=style&index=0&id=a729b11e&lang=less&scoped=true"

import exportComponent from "F:\\project\\trade_lab_frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a729b11e"]])

export default __exports__